export const ExampleTableStyle = {
  width: '100%',
  position: 'relative',
  '& table': {
    width: '100%',
  },
  '& td, & tr th': {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    borderSpacing: 0,
    border: '1px solid #ccc',
    padding: '2px 4px',
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(0deg, white, transparent)',
    pointerEvents: 'none',
  },
};